import { render, staticRenderFns } from "./AppSettingsPopup.vue?vue&type=template&id=4c9587bb&scoped=true&"
import script from "./AppSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./AppSettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsPopup.vue?vue&type=style&index=0&id=4c9587bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9587bb",
  null
  
)

export default component.exports